import { Pipe, PipeTransform } from '@angular/core';
import { Cbsa } from '../api/standardschedule.service';

@Pipe({ name: 'cbsa' })
export class CbsaPipe implements PipeTransform {
  transform(cbsa: Cbsa): string {
    return `${cbsa.code} ${cbsa.name.slice(0, 30)}`;
  }
}
